document.addEventListener("DOMContentLoaded", function () {
  updateCartUI();

  // Sidebar toggle function
  window.toggleSidebar = function () {
    var sidebar = document.getElementById("sidebar");
    var overlay = document.getElementById("overlay");
 
    sidebar.classList.toggle("active");
    overlay.classList.toggle("active");

    if (sidebar.classList.contains("active")) {
      overlay.style.display = "block";
    } else {
      overlay.style.display = "none";
    }
    updateCartUI();
  };

 function updateCartUI() {
  fetch("/cart.js")
    .then((response) => response.json())
    .then((cart) => {
      let cartContainer = document.querySelector(".cart_height ul");
      cartContainer.innerHTML = "";
      if (cart.items.length === 0) {
        cartContainer.innerHTML =
          "<p class='text-black'>Your cart is empty...</p>";
      } else {
        cart.items.forEach((item) => {
          let truncatedTitle =
            item.product_title.length > 40
              ? item.product_title.substring(0, 40) + "..."
              : item.product_title;

          let unitPrice = (item.price / 100).toFixed(2); // Calculate unit price
          let totalPrice = (item.final_line_price / 100).toFixed(2); // Calculate total price

          let listItem = document.createElement("li");
          listItem.className = "cart_a_tag cart_width";
          listItem.dataset.cartItemKey = item.key;
          listItem.innerHTML = `
            <div class="cart_image_width">
              <a><img src="${item.image}" alt="${item.product_title}" /></a>
            </div>
            <div class="cart_text_delete">
              <div class="w-100">
                <p class="mb-0 cart_margin title_size">${truncatedTitle}</p>
                
                <p class="cart_margin_bottom">Variant: ${item.variant_title ? item.variant_title : "Default"}</p>
                <div class="header-quantity-gap">
                <div class="input-quantity-wrappers">
                  <span class="minus-icon" data-cart-item-key="${item.key}"></span>
                  <input type="number" min="1" step="1" value="${item.quantity}" data-cart-item-key="${item.key}">
                  <span class="plus-icon" data-cart-item-key="${item.key}"></span>
                </div>
                <p class="cart_margin item-price" data-cart-item-key="${item.key}"> $${unitPrice}</p> 
                <p class="cart_margin item-price total_price_color" data-cart-item-key="${item.key}"><span class="card_text_black">Total:</span> $${totalPrice}</p> 
                </div>
              </div>
              <div>
               <svg class="remove-from-cart-button" data-cart-item-key="${item.key}" width="21" height="22" viewBox="0 0 21 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M16.5938 22C17.538 22 18.2818 21.2894 18.3106 20.3514L18.8542 4.12124H21V2.98438H14.9632V1.76224C14.9632 0.795875 14.1621 0 13.1894 0H7.81061C6.83791 0 6.03681 0.795875 6.03681 1.76224V2.98438H0V4.12124H2.14579L2.68944 20.3514C2.71798 21.2894 3.46197 22 4.40617 22H16.5938ZM7.18098 1.76204C7.18098 1.42101 7.46716 1.13671 7.81041 1.13671H13.1892C13.5324 1.13671 13.8186 1.42103 13.8186 1.76204V2.98418H7.18098V1.76204ZM3.83355 20.323L3.2899 4.12124H17.681L17.1373 20.323C17.1373 20.6357 16.8799 20.8631 16.5652 20.8631H4.40571C4.11972 20.8631 3.86206 20.6357 3.83355 20.323Z" fill="red"></path>  <!-- Change fill to "red" -->
              </svg>
              </div>
            </div>
          `;
          cartContainer.appendChild(listItem);
        });

        // Attach event listeners to plus and minus buttons after rendering
        attachQuantityListeners();
      }
    })
    .catch((error) => console.error("Cart fetch error:", error));
}

  function attachQuantityListeners() {
    document.querySelectorAll('.input-quantity-wrappers').forEach(wrapper => {
      wrapper.addEventListener('click', function(event) {
        const target = event.target;
        const key = target.dataset.cartItemKey;
        const input = wrapper.querySelector('input[type="number"]');
        let quantity = parseInt(input.value);

        if (!key) return;

        if (target.classList.contains('plus-icon')) {
          quantity++;
        } else if (target.classList.contains('minus-icon')) {
          quantity = Math.max(1, quantity - 1); // Ensure quantity is not less than 1
        }

        // Update the input field
        input.value = quantity;

        // Update the cart and the price
        updateCartItemQuantity(key, quantity);
      });
    });

    // Also, add an event listener for direct input changes
    document.querySelectorAll('.input-quantity-wrappers input[type="number"]').forEach(input => {
      input.addEventListener('change', function(event) {
        const key = event.target.dataset.cartItemKey;
        let quantity = parseInt(event.target.value);

        if (!key) return;

        // Ensure quantity is not less than 1
        quantity = Math.max(1, quantity);
        event.target.value = quantity; // Update the input to the valid quantity

        updateCartItemQuantity(key, quantity);
      });
    });
  }

  function updateCartItemQuantity(key, quantity) {
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then((response) => response.json())
      .then(() => {
        console.log(`Quantity updated for item ${key} to ${quantity}`);
        updateCartUI(); // Refresh the entire cart UI
      })
      .catch((error) => {
        console.error("Cart change error:", error);
        alert("Failed to update quantity. Please try again.");
        updateCartUI(); // Revert to the previous state on error
      });
  }


  document.querySelectorAll(".cart_height ul").forEach((cartList) => {
    cartList.addEventListener("click", function (event) {
      if (event.target.classList.contains("remove-from-cart-button")) {
        const key = event.target.dataset.cartItemKey;
        const listItem = event.target.closest(".cart_a_tag");

        if (!key || !listItem) return;

        listItem.remove(); // Optimistic update: Remove immediately

        fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ id: key, quantity: 0 }),
        })
          .then((response) => response.json())
          .then(() => {
            alert("Product has been deleted from the cart."); // Alert on successful deletion
            console.log("Item deleted successfully from cart:", key);
          })
          .catch((error) => {
            console.error("Cart change error:", error);
            alert("Failed to delete the product. Please try again."); // Error alert
            updateCartUI(); // Only re-fetch on error
          });
      }
    });
  });

  document
    .querySelectorAll(".close-btn, #overlay")
    .forEach((el) => {
      el.addEventListener("click", function (event) {
        event.preventDefault();
        toggleSidebar();
      });
    });

  document.addEventListener("cart:added", function () {
    updateCartUI();
  });

  document.querySelectorAll(".addToCartButton").forEach((button) => {
    button.addEventListener("click", function () {
      const productId = this.dataset.productId;

      fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          id: productId,
          quantity: 1,
        }),
      })
        .then((response) => response.json())
        .then((data) => {
          document.dispatchEvent(new CustomEvent("cart:added"));
          console.log("Product added to cart!");
          toggleSidebar();
        })
        .catch((error) => console.error("Error adding to cart:", error));
    });
  });
});